import React from 'react'
import './testimonials.css'






const Testimonials = () => {
  return (
   <section id="testimonials">
     <h2>Testimonial</h2>
   <div className="container testimonials__container">
    <div className="testimonial">
      <h5 className="client__name">Zak Hassan - Senior Software Developer at Workday</h5>
      <small className="client_review">Warsame is a very talented engineer. He can work on Fullstack applications in Java and Sprintboot. He is able to work on ReactJS and do CRUD on PostgreSQL database. He is also able to deploy all of this on AWS cloud. For local development he was able to build a docker-compose environment to test his application locally. After working with Warsame I saw how talented he is. I think any company he works for when he graduates is truly getting a rockstar. Warsame is beyond his years of experience. </small>
    </div>
    </div>

    </section>
  )
}

export default Testimonials
